(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4g-features-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('#features-5g .feature-card');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.style.opacity = '0';
                    entry.target.style.transform = 'translateY(20px)';
                    requestAnimationFrame(() => {
                        entry.target.style.transition = 'all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
                        entry.target.style.opacity = '1';
                        entry.target.style.transform = 'translateY(0)';
                    });
                }, index * 100);
            }
        });
    }, {
        threshold: 0.1
    });
    
    cards.forEach(card => observer.observe(card));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["5g-features-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('#features-5g .feature-card');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.style.opacity = '0';
                    entry.target.style.transform = 'translateY(20px)';
                    requestAnimationFrame(() => {
                        entry.target.style.transition = 'all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
                        entry.target.style.opacity = '1';
                        entry.target.style.transform = 'translateY(0)';
                    });
                }, index * 100);
            }
        });
    }, {
        threshold: 0.1
    });
    
    cards.forEach(card => observer.observe(card));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collocation-counter-section"]) return;
  try {
    
  	$(document).ready(function() {

  var counters = $(".count");
  var countersQuantity = counters.length;
  var counter = [];

  for (i = 0; i < countersQuantity; i++) {
    counter[i] = parseInt(counters[i].innerHTML);
  }

  var count = function(start, value, id) {
    var localStart = start;
    setInterval(function() {
      if (localStart < value) {
        localStart++;
        counters[id].innerHTML = localStart;
      }
    }, 200);
  }

  for (j = 0; j < countersQuantity; j++) {
    count(0, counter[j], j);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-collocation-section"]) return;
  try {
    
  var action="click"; 
var speed="500";

$(document).ready(function() { 
    // Question handler
    $('.accordion-item .q').on(action, function() {
        // Get next element
      // $(this).toggleClass("red");
      // $('.accordion-item .red').css("background-color","yellow");
        $(this).next()
            .slideToggle(speed)
          
        // Select all other answers
                .siblings('.accordion-item .a') 
                    .slideUp();
    });
});
  $('.accordion-item').click(function() {
    $(this).toggleClass("red");
});    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["light-faq-section"]) return;
  try {
    
  var action="click"; 
var speed="500";

$(document).ready(function() { 
    // Question handler
    $('.accordion-item .q').on(action, function() {
        // Get next element
      // $(this).toggleClass("red");
      // $('.accordion-item .red').css("background-color","yellow");
        $(this).next()
            .slideToggle(speed)
          
        // Select all other answers
                .siblings('.accordion-item .a') 
                    .slideUp();
    });
});
  $('.accordion-item').click(function() {
    $(this).toggleClass("red");
});    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-key-benefits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.kuma-benefits-swiper', {
    slidesPerView: 3,
    spaceBetween: 24,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      0: { slidesPerView: 1 }
    },
    autoplay: {
      delay: 2000, // Slide every 3 seconds
      disableOnInteraction: false
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-choosing-4g-sim-card-light-faq-section-1"]) return;
  try {
    
  var action="click"; 
var speed="500";

$(document).ready(function() { 
    // Question handler
    $('.accordion-item .q').on(action, function() {
        // Get next element
      // $(this).toggleClass("red");
      // $('.accordion-item .red').css("background-color","yellow");
        $(this).next()
            .slideToggle(speed)
          
        // Select all other answers
                .siblings('.accordion-item .a') 
                    .slideUp();
    });
});
  $('.accordion-item').click(function() {
    $(this).toggleClass("red");
});    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-light-faq-section"]) return;
  try {
    
  var action="click"; 
var speed="500";

$(document).ready(function() { 
    // Question handler
    $('.accordion-item .q').on(action, function() {
        // Get next element
      // $(this).toggleClass("red");
      // $('.accordion-item .red').css("background-color","yellow");
        $(this).next()
            .slideToggle(speed)
          
        // Select all other answers
                .siblings('.accordion-item .a') 
                    .slideUp();
    });
});
  $('.accordion-item').click(function() {
    $(this).toggleClass("red");
});    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-lp-campervan-light-faq-section"]) return;
  try {
    
  var action="click"; 
var speed="500";

$(document).ready(function() { 
    // Question handler
    $('.accordion-item .q').on(action, function() {
        // Get next element
      // $(this).toggleClass("red");
      // $('.accordion-item .red').css("background-color","yellow");
        $(this).next()
            .slideToggle(speed)
          
        // Select all other answers
                .siblings('.accordion-item .a') 
                    .slideUp();
    });
});
  $('.accordion-item').click(function() {
    $(this).toggleClass("red");
});    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-lp-motorhome-light-faq-section"]) return;
  try {
    
  var action="click"; 
var speed="500";

$(document).ready(function() { 
    // Question handler
    $('.accordion-item .q').on(action, function() {
        // Get next element
      // $(this).toggleClass("red");
      // $('.accordion-item .red').css("background-color","yellow");
        $(this).next()
            .slideToggle(speed)
          
        // Select all other answers
                .siblings('.accordion-item .a') 
                    .slideUp();
    });
});
  $('.accordion-item').click(function() {
    $(this).toggleClass("red");
});    


  } catch(e) { console.error(e); }
})();
})();
